import { defineStore } from 'pinia';
import { ref, computed } from 'vue'
import { navigateTo } from '@/utils/router';
import api from '@/api/auth';

export const useAuthStore = defineStore('auth', () => {
  // 状态
  const token = ref(localStorage.getItem('token') || null);
  const refreshToken = ref(localStorage.getItem('refreshToken') || null);
  const user = ref(JSON.parse(localStorage.getItem('user')) || null);
  const hasRoutes = ref(false);

  // 计算属性
  const isLoggedIn = computed(() => !!token.value)
  const isAdmin = computed(() => user.value?.role === 'admin')

  // 方法 - 登录
  async function login(loginForm) {
    try {
      const response = await api.login(loginForm)
      console.log("--------", response)
      token.value = response.access
      refreshToken.value = response.refresh
      user.value = response.user
      localStorage.setItem('token', response.access)
      localStorage.setItem('refreshToken', response.refresh)
      localStorage.setItem('user', JSON.stringify(response.user))
    } catch (error) {
      await logout()
      throw error
    }
  }
  
  // 方法 - 清理用户登录信息
  function clearUser() {
    token.value = null
    user.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
  }

  // 方法 - 退出
  async function logout() {
    token.value = null
    user.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
    await api.logout();
    navigateTo("/login")
  }

  // 方法 - 获取用户信息
  async function fetchUser() {
    if (token.value) {
      try {
        user.value = await api.getUser()
      } catch (error) {
        await logout()
        throw error
      }
    }
  }
  
  // 方法 - 初始化认证状态
  async function initialize() {
    if (token.value && !user.value) {
      await fetchUser()
    }
  }
  
// refresh token
  async function refresh() {
    try {
      const response = await api.refresh({refresh: refreshToken.value})
      token.value = response.access
      refreshToken.value = response.refresh
      user.value = response.user
      localStorage.setItem('token', response.access)
      localStorage.setItem('refreshToken', response.refresh)
      localStorage.setItem('user', JSON.stringify(response.user))
    } catch (error) {
      await logout()
      throw error
    }
  } 

  function setHasRoutes(value) {
    hasRoutes.value = value
  }

  return {
    token,
    user,
    isLoggedIn,
    isAdmin,
    hasRoutes,
    login,
    logout,
    fetchUser,
    initialize,
    refresh,
    setHasRoutes,
    clearUser
  }
})